import type { ApolloCache } from '@apollo/client';

// TA-10162 (attachment path): the draft entry in listDraftMessages is the
// ONLY render source for a just-sent message until the publish mutation
// response lands. The message's listMessages edge (written by useSendMessage)
// normalizes into Message:{clientId} with an INCOMPLETE draft Document
// (no owner/createdAt/taskDocuments), which keeps the open thread's
// listMessages read incomplete — the hook serves its last complete snapshot,
// WITHOUT the new message. Removing the draft entry before the message is
// published therefore blanks the message out of the thread until the
// publish response completes the entity. Callers must only remove the draft
// entry once the message is published (or can never publish).
//
// Implemented with cache.modify rather than cache.updateQuery: updateQuery
// re-reads the whole ListDraftMessages selection first, and any incomplete
// draft in the list makes that read return undefined — silently turning the
// removal into a no-op and leaking sent drafts into the list forever.
// cache.modify filters the refs directly and cannot be blocked that way.
export const removeDraftMessageEntry = (
  cache: ApolloCache<unknown>,
  clientId: string
): void => {
  cache.modify({
    fields: {
      listDraftMessages(existing, { readField }) {
        if (!Array.isArray(existing)) return existing;
        return existing.filter(
          (ref) => readField<string>('clientId', ref) !== clientId
        );
      },
    },
  });
};
